import ContentLayout from "../../layout/contentLayout";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { Content } from "./content";
/**
 * WalletFinancialReports
 *
 * کامپوننت صفحه گزارش ها مالی کیف پول پذیرنده.
 *
 * ویژگی‌ها:
 *  - نمایش عنوان صفحه و آیکون مرتبط با موجودی کیف پول
 *  - استفاده از ContentLayout برای ساختار صفحه با قابلیت Container Fluid
 *  - نمایش کامپوننت Content که شامل نمودارها، جدول تراکنش‌ها و فیلترها است
 *
 * @returns کامپوننت React حاوی گزارش ها مالی کیف پول
 */

const WalletFinancialReports = () => {
  // const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");

  return (
    <ContentLayout icon={<AccountBalanceWalletOutlinedIcon className="w-[50px] h-[50px]" />} title="گزارش ها مالی کلی پذیرنده" isContainerFluid>
      <Content />
    </ContentLayout>
  );
};

export default WalletFinancialReports;
